import { generatePath } from 'react-router-dom';

import { ACTION_TYPES, ENDPOINT_ROUTE_MAP } from './constants';
import { typeHandlersMap } from './utils';

import type { Middleware } from '@reduxjs/toolkit';
import type { RootState } from 'app/providers/StoreProvider/types';

export const dynamicCrumbs: Middleware<{}, RootState> =
  store => next => action => {
    if (ACTION_TYPES.includes(action.type)) {
      const { getState, dispatch } = store;
      const { dynamicCrumb } = getState().breadcrumbs;
      const { payload, meta } = action;
      const { endpointName: metaEndpointName, originalArgs } = meta.arg;

      Object.entries(ENDPOINT_ROUTE_MAP).forEach(
        ([key, { endpointName, titleGetter }]) => {
          if (metaEndpointName !== endpointName) return;

          const pathname = generatePath(key, originalArgs);

          const { [pathname]: breadcrumb } = dynamicCrumb;

          const typeHandlersMapInitiated = typeHandlersMap({
            breadcrumb,
            dispatch,
            pathname,
            titleGetter,
            payload,
          });

          typeHandlersMapInitiated[action.type]();
        },
      );
    }

    return next(action);
  };
